/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Notification = {

	deleteGroup (context, notificationGroupId, onSuccess, onError, options) {
		Api.delete(context,
			"/notification/group"
			+ "?notificationGroupId=" + notificationGroupId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteNotificationGroupUser (context, userId, notificationGroupId, onSuccess, onError, options) {
		Api.delete(context,
			"/notification/notification-group-user"
			+ "?userId=" + userId
			+ "&notificationGroupId=" + notificationGroupId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDepartmentUsersToAdd (context, systemRole, departmentId, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/notification/department-users-to-add"
			+ "?systemRole=" + systemRole
			+ "&departmentId=" + departmentId
			+ "&notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGroupName (context, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/notification/group-name"
			+ "?notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGroupUsers (context, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/notification/group-users"
			+ "?notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGroups (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/notification/groups"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsersToAdd (context, systemRole, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/notification/users-to-add"
			+ "?systemRole=" + systemRole
			+ "&notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAgencyContestEvaluatorsNotification (context, title, message, contestId, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/agency-contest-evaluators-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&contestId=" + contestId
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAgencyEmployeesNotification (context, title, message, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/agency-employees-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postBiddersNotification (context, title, message, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/bidders-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postContestBiddersNotification (context, title, message, contestId, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/contest-bidders-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&contestId=" + contestId
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postContestEvaluatorsNotification (context, title, message, contestId, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/contest-evaluators-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&contestId=" + contestId
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postContestVolunteersNotification (context, title, message, contestId, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/contest-volunteers-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&contestId=" + contestId
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDepartmentEmployeesNotification (context, title, message, departmentId, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/department-employees-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&departmentId=" + departmentId
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postGroup (context, createGroupDTO, onSuccess, onError, options) {
		Api.post(context,
			"/notification/group"
			, createGroupDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postGroupNotification (context, files, title, message, groupId, onSuccess, onError, options) {
		Api.post(context,
			"/notification/group-notification"
			+ "?files=" + files
			+ "&title=" + title
			+ "&message=" + message
			+ "&groupId=" + groupId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postNotificationGroupUser (context, notificationGroupUserDTO, onSuccess, onError, options) {
		Api.post(context,
			"/notification/notification-group-user"
			, notificationGroupUserDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postVolunteersNotification (context, title, message, files, onSuccess, onError, options) {
		Api.post(context,
			"/notification/volunteers-notification"
			+ "?title=" + title
			+ "&message=" + message
			+ "&files=" + files
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putGroup (context, updateGroupDTO, onSuccess, onError, options) {
		Api.put(context,
			"/notification/group"
			, updateGroupDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
